var Handlebars = require("/Users/mauricengo/styleguide-test/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper;

  return container.escapeExpression(((helper = (helper = helpers["delivery-date"] || (depth0 != null ? depth0["delivery-date"] : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"delivery-date","hash":{},"data":data}) : helper)));
},"3":function(container,depth0,helpers,partials,data) {
    return "You will not be charged until your order is shipped";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "\n<div class=\"notification\">\n  <h3 class=\"notification__head\">Available for Preorder!</h3>\n  <p class=\"notification__description\">You will not be charged until your item is shipped</p>\n  <p class=\"delivery-date\">Estimated Delivery: "
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},(depth0 != null ? depth0["delivery-date"] : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "</p>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/materials/modules/product-notifications/preorder-available.html
// module id = 164
// module chunks = 0